<header class="background-header">
	<img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img" [ngClass]="{backgroundWidth: themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
</header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container friend-invitation-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>My Plan <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Friend Invitation'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Invite A Friend</h1>
			</div>
		</section>
		<section class="jumbotron donation-info margin-upside-down">
			<div class="icon">
				<img src="../../assets/img/{{themeService.theme}}/charity.svg" alt="Logo Charity Zenplans">
			</div>
			<div class="donation">
				<div class="title">Earn £10 for your favourite charity</div>
				<div class="subtitle">For each friend that joins Zenplans we'll make a donation to one of our charity partners.</div>
			</div>
			<div class="triangle"></div>
		</section>
		<section class="friend-invitation-charity">
			<div class="step-container select-charity">
				<div class="circle">
					<span class="step">1</span>
				</div>
				<div class="step-text">Select Your Charity</div>
			</div>
			<div class="charity-card">
				<div class="item-charity-box">
					<div class="charity-box"></div>
					<img src="../../assets/../../assets/img/{{themeService.theme}}/check-item.svg.svg" alt="">
				</div>
				<div class="item-charity-box">
					<div class="charity-box"></div>
					<img src="../../assets/../../assets/img/{{themeService.theme}}/check-item.svg.svg" alt="">
				</div>
				<div class="item-charity-box">
					<div class="charity-box"></div>
					<img src="../../assets/../../assets/img/{{themeService.theme}}/check-item.svg.svg" alt="">
				</div>
				<div class="item-charity-box">
					<div class="charity-box"></div>
					<img src="../../assets/../../assets/img/{{themeService.theme}}/check-item.svg.svg" alt="">
				</div>
				<div class="item-charity-box">
					<div class="charity-box"></div>
					<img src="../../assets/../../assets/img/{{themeService.theme}}/check-item.svg.svg" alt="">
				</div>
				<input class="form-control btn btn-primary primary-sml-btn" type="button" value="More">
			</div>
		</section>
		<section class="friend-invitation-sharing">
			<div class="step-container sharing">
				<div class="circle">
					<span class="step">2</span>
				</div>
				<div class="step-text">Share your personal invitation link with a friend</div>
			</div>
			<div class="charity-form">
				<input type="email" class="form-control col-12 col-sm-7 col-md-7" placeholder="Short Code">
				<input type="button" class="form-control btn btn-primary primary-lg-btn col-12 col-sm-2 col-md-2"
					   value="Copy Link" (click)="goTo()">
			</div>
		</section>
	</section>
</section>
